/**
 * Created by Jason on 2017-3-6.
 */
/**
 * 左边菜单管理
 */
import util from './util'
import PNotify from '../lib/pnotify/js/pnotify';


// {
//     //notify初始化
//     PNotify.prototype.options.styling = "fontawesome";
// }
// //ajax初始化
// //给所有ajax请求加上header:token
// {
//     let token = oc.getToken();
//     jQuery.ajaxSetup({
//         accepts: {
//             json: 'application/json'
//         },
//         beforeSend (xhr) {
//             if (token) {
//                 xhr.setRequestHeader('Token', token);
//             }
//         },
//         crossDomain: true,
//         dataType: 'text',
//         dataFilter(json) {
//             json = JSON.parse(json);
//             if (json.status != 0) {
//                 let title, text;
//                 if (json.status == 10) {
//                     title = '登录错误';
//                     text = '请等待3秒重新登录。';
//                     setTimeout(logout, 3000);
//                 } else {
//                     title = '出错了';
//                     text = json.msg;
//                 }
//                 new PNotify({
//                     title: title,
//                     text: text,
//                     type: 'error',
//                     opacity: .8,
//                     buttons: {
//                         sticker: false
//                     }
//                 });
//             }
//             return json;
//         },
//         error() {
//             new PNotify({
//                 title: '网络错误',
//                 type: 'error',
//                 text: false,
//                 opacity: .8,
//                 buttons: {
//                     sticker: false
//                 }
//             });
//         }
//     })
// }
//
// //左边菜单
// {
//     let navUrl = oc.navUrl;
//     let navData = oc.navData;
//     let $sidebarMenu = $("#sidebar-menu");
//
//     main.ready((userData) => {
//         let identityType = userData.identityType || 'CUSTOM';
//         // let identityType = "ADMIN";
//         let identityNav, navItem;
//         let html = ``;
//         let path = location.pathname.replace(/\/|\.html/, '') || 'index';
//         identityNav = navData[identityType] || [];
//         for (let i = 0, lenP = identityNav.length; i < lenP; i++) {
//             html += renderNavItem(identityNav[i]);
//
//         }
//         $sidebarMenu.html(html);
//         checkMenu();
//
//         function renderNavItem(data) {
//             navItem = navUrl[data];
//             html = '<li class="';
//             //独立菜单
//             if (navItem.isParent) {
//                 html += `is-parent">${navItem.name}</li>`;
//             } else {
//                 if (navItem.isIcon) {
//                     html += `is-icon" title="${navItem.name}">`;
//                 } else {
//                     html += '">';
//                 }
//                 if (data === path) {
//                     html += `<a class="active" `;
//                 } else {
//                     html += `<a `;
//                 }
//                 html += `data-type="${navItem.id || 0}" href="${navItem.url}">
//                     <i class="topic-type-${navItem.id} fa fa-fw fa-${navItem.icon}"></i>
//                     <span>${navItem.name}</span>
//                     </a>
//                 </li>`;
//             }
//             return html;
//         }
//     });
//     //高亮菜单
//     let $check = null;
//     function checkMenu() {
//         //todo 高亮菜单
//         let hash = location.hash;
//         let pathname = location.pathname === '/' ? '/index.html' : location.pathname;
//         let $nav = $sidebarMenu.find("a[href=\"" + pathname + hash + "\"]");
//         if (pathname === '/topic.html' && !hash) {
//             if (!$nav.length) {
//                 $nav = $sidebarMenu.find("a[href=\"/topic.html\"]");
//             }
//         }
//         $check = $nav;
//         $nav.addClass('check');
//     }
// }
//
//
// //初始化用户数据
// $.get(SERVER + '/myInfo/userInfo', (json) => {
//     let userData = json.data;
//     let companyList = userData.companyList;
//     let len = companyList.length;
//     let cacheCompanyId = oc.getCompanyId();
//     let $headerCompanyAccount = $("#header-company-account")
//     //处理公司
//     if(len > 1) {
//         let html = '';
//         let isCacheCompany = false;
//         companyList.forEach((item) => {
//             html += `<li><a href="javascript:;" data-company-id="${item.companyId}">${item.name}</a></li>`;
//             if (cacheCompanyId == item.companyId) {
//                 checkCompany(item);
//                 isCacheCompany = true;
//             }
//         });
//         if (!isCacheCompany) {
//             checkCompany(companyList[0]);
//         }
//         $("#change-company-list").html(html).on('click', 'a', (e) => {
//             let companyId = $(e.target).data('company-id');
//             if (companyId == cacheCompanyId) {
//                 return;
//             }
//             oc.saveCompanyId(companyId);
//             location.reload();
//         });
//         //可以下拉
//         $headerCompanyAccount.next().show();
//
//     } else if (len === 1) {
//         checkCompany(companyList[0]);
//         $headerCompanyAccount.closest('.menu-active').removeAttr('data-toggle');
//     } else {
//         logout();
//     }
//
//     function checkCompany(company) {
//         if (company.userType == 3) {
//             $('#user-manage').hide();
//         }
//         oc.saveCompanyId(company.companyId);
//         $headerCompanyAccount.html(company.name);
//         userData.company = company;
//     }
//     //处理用户信息
//     $("#header-user-account").html(userData.name);
//     oc.trigger(userData);
// });
//



let main = {
    //增加回掉
    ready (fn) {
        if (bootstrap._userData) {
            fn(_userData)
        } else {
            bootstrap._fnList.push(fn)
        }
    }
}

export default main
//启动
let bootstrap = {
    _userData: null,
    _fnList: [],
    token: null,

    //移动端访问做跳转
    checkClient () {
        if (/(Android|iPhone)/i.test(navigator.userAgent)) {
            location.replace('http://m.custom.orancrab.com/login.html')
            return false
        }
        return true
    },

    /**
     * 是否登录判断
     * @returns {boolean}
     */
    checkLogin () {
        let token = this.token = util.getToken()
        if (!token) {
            util.logout()
            return false
        }
        return true
    },

    //notify初始化
    initPNotify () {
        PNotify.prototype.options.styling = 'fontawesome'
    },

    //初始化ajax
    initAjax () {
        jQuery.ajaxSetup({
            accepts: {
                json: 'application/json'
            },
            beforeSend (xhr) {
                xhr.setRequestHeader('Token', util.getToken())
            },
            crossDomain: true,
            dataType: 'text',
            dataFilter (json) {
                json = JSON.parse(json)
                if (json.status === 10) {
                    util.logout()
                } else if (json.status !== 0) {
                    new PNotify({
                        title: '出错了',
                        text: json.msg,
                        type: 'error',
                        opacity: .8,
                        buttons: {
                            sticker: false
                        }
                    })
                }
                return json
            },
            error () {
                new PNotify({
                    title: '网络错误',
                    type: 'error',
                    text: false,
                    opacity: .8,
                    buttons: {
                        sticker: false
                    }
                })
            }
        })
    },

    /**
     * 初始化菜单
     */
    getNav (userData) {
        let ts = this;
        let $sidebarMenu = $("#sidebar-menu");
        let $proNavs = $sidebarMenu.find(".pro-navs");
        let pathname = location.pathname === '/' ? '/index.html' : location.pathname;

        //获取产品
        $.get(SERVER + '/product/getProduct', (json) => {

            //产品菜单
            let htmlType1 = `
                    <h3>常规产品</h3>
                    <ul class="pro-nav">
                `;
            let htmlType2 = `
                    <h3>促销产品</h3>
                    <ul class="pro-nav">
                `;
            let htmlType3 = `
                    <h3>咨询反馈</h3>
                    <ul class="pro-nav">
                        <li><a href="/feedback-list.html"><i class="fa fa-reply"></i>用户反馈</a></li>
                `
            let htmlType4 = '';
            if (json.data) {
                json.data.forEach((item) => {
                    let html = `<li><a href="${(item.url || '').trim()}" data-type="${item.productId}"><i class="fa fa-${item.productIcon}"></i>${item.productName}</a></li>`;
                    switch (item.productType) {
                        case 1:
                            htmlType1 += html
                            break;
                        case 2:
                            htmlType2 += html
                            break;
                    }
                });
            }
            
            $proNavs.html(htmlType1 + `</ul>` + htmlType2 + `</ul>` + htmlType3 + `</ul>` + htmlType4);

            checkMenu();

            let productDataMap = ts.getProductDataMap(json.data);
            let productDataName = ts.getProductDataName(json.data);
            //初始化完成
            ts._fnList.forEach((fn) => {
                fn(userData, json.data, productDataMap, productDataName);
            })
        });
        //高亮菜单
        let $check = null;

        function checkMenu() {
            let hash = location.hash;
            let $nav = $sidebarMenu.find("a[href=\"" + pathname + hash + "\"]");
            if (pathname === '/topic.html' && !hash) {
                if (!$nav.length) {
                    $nav = $sidebarMenu.find("a[href=\"/topic.html#0\"]");
                }
            }
            if ($nav.length) {
                $check = $nav;
                $nav.addClass('check');
            }
        }

        //主题高亮菜单
        if (pathname === '/topic.html') {
            $sidebarMenu.on('click', (e) => {
                let $closest = $(e.target).closest('a');
                if ($closest.length && $closest.attr('href').indexOf('/topic.html') !== -1) {
                    if ($check) {
                        $check.removeClass('check');
                    }
                    $check = $closest;
                    $closest.addClass('check');
                }
            })
        }
    },

    getProductDataMap(productData) {
        let productDataMap = {};
        productData.forEach((item) => {
            let productTasksMap = {};
            item.productTasks.forEach((taskItem) => {
                productTasksMap[taskItem.productTaskId + ''] = taskItem;
            });
            item.productTasksMap = productTasksMap;
            productDataMap[item.productId + ''] = item;
        });

        return productDataMap;
    },

    getProductDataName(productData) {
        let taskNameCache = {};
        productData.forEach((item) => {
            item.productTasks.forEach((child) => {
                taskNameCache[child.productTaskId] = {
                    productName: item.productName,
                    taskName: child.taskName
                };
            })
        })
        return taskNameCache;
    },

    _initFrame (userData) {
        let companyList = userData.companyList;
        let len = companyList.length;
        let cacheCompanyId = util.getCompanyId();
        let $headerCompanyAccount = $("#header-company-account")
        //处理公司
        if(len > 1) {
            let html = '';
            let isCacheCompany = false;
            companyList.forEach((item) => {
                html += `<li><a href="javascript:;" data-company-id="${item.companyId}">${item.name}</a></li>`;
                if (cacheCompanyId == item.companyId) {
                    checkCompany(item);
                    isCacheCompany = true;
                }
            });
            if (!isCacheCompany) {
                checkCompany(companyList[0]);
            }
            $headerCompanyAccount.find('ul').html(html).on('click', 'a', (e) => {
                let companyId = $(e.target).data('company-id');
                if (companyId == cacheCompanyId) {
                    return;
                }
                util.saveCompanyId(companyId);
                location.reload();
            });
            //可以下拉
            $headerCompanyAccount.css('display', 'inline-block');

        } else if (len === 1) {
            checkCompany(companyList[0]);
        } else {
            logout();
        }

        function checkCompany(company) {
            if (company.userType == 3) {
                $('#user-manage').hide();
            }
            util.saveCompanyId(company.companyId);
            $headerCompanyAccount.find('span').html(company.name);
            userData.company = company;
        }
        //处理用户信息
        $("#header-user-account").html(userData.name);
        //登出
        $('#logout').on('click', () => {
            util.logout();
        });
    },

    /**
     * 获取用户信息
     */
    getUserInfo () {
        $.get(SERVER + '/myInfo/userInfo', (json) => {
            //触发回掉
            this._userData = json.data;
            this.getNav(json.data);
        })
    },

    /**
     * 启动
     */
    start () {

        let ts = this

        if (!ts.checkClient() || !ts.checkLogin()) {
            return
        }

        ts.initPNotify()

        ts.initAjax()

        main.ready((userData) => {
            ts._initFrame(userData)
        })

        ts.getUserInfo()

    }

}

bootstrap.start()


// WEBPACK FOOTER //
// ./src/assets/js/main.js